import classes from './MenuHeaders.module.css';
import cup from '../img/cup.jpeg';
import food from '../img/food.jpeg';
import shake from '../img/shake.jpeg';
import pizza from '../img/pizza.jpeg';
import drink from '../img/drink.jpeg';
import coctail from '../img/coctail.jpeg';

const MenuHeaders = (props) => {

    return (
        <div className={classes.maincontainer}>

<div className={classes.row}>
<div  className={classes.row_item} onClick={props.OnShowDrinks}>
<p className='text-brown'>Café</p>
<img className={classes.icon} src={cup}></img>
</div>

<div className={classes.row_item} onClick={props.OnShowFoods}>
<p className='text-orange'>Pizza</p>
<img className={classes.icon} src={pizza}></img>
</div>
</div>


<div className={classes.row}>
<div className={classes.row_item} onClick={props.OnShowShakes}>
<p className='text-shake'>Shake</p>
<img className={classes.icon} src={shake}></img>
</div>
<div className={classes.row_item} onClick={props.OnShowCoctails}>
<p className='text-red'>Foods</p>
<img className={classes.icon} src={food}></img>
</div>
</div>


<div className={classes.row}>
<div className={classes.row_item} onClick={props.OnShowMainFoods}>
<p className='text-coctail'> Coctails</p>
<img className={classes.icon} src={coctail}></img>
</div>
<div className={classes.row_item} onClick={props.OnShowColas}>
<p className='text-brown'>Cola</p>
<img className={classes.icon} src={drink}></img>
</div>
</div>





        </div>
    )

}
export default MenuHeaders;